/* @flow */
import { uniqueId } from 'lodash';
import { CONSENT_CHARGE_AMOUNT } from 'constants/ParentalConsentConstants';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as React from 'react';
import BoxBody from 'components/BoxBody';
import BoxHeader from 'components/BoxHeader';
import Button from 'components/ButtonDeprecated';
import Checkbox from 'components/Checkbox';
import Config from 'Config';
import CreditCardInput from 'components/CreditCardInput';
import CurrentUser from 'auth/CurrentUser';
import EncryptionNotice from 'components/EncryptionNotice';
import FamilyActions from 'actions/FamilyActions';
import Field from 'components/Field';
import Input from 'components/Input';
import Label from 'components/Label';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';
import ModalTrigger from 'components/ModalTrigger';
import ParentalConsentPersonalInfoModal from 'user/components/ParentalConsentPersonalInfoModal';
import { setStripeCallStatus, reinitialize } from 'reducers/creditCards';
import ToastActions from 'actions/ToastActions';

type State = {
  name: string,
  nameError: boolean | string,
  nameId: string,
  safetyPolicy: boolean,
  safetyPolicyError: boolean | string,
  submitting: boolean,
};

type Props = {
  childId: number,
  onProceed: Function,
  // redux
  inputValid: boolean,
  errorMessage: ?string,
  stripeCallStatus: ?string,
  setStripeCallStatus: Function,
  sourceId: ?string,
  reinitialize: Function,
};

class ParentalConsentCardView extends React.Component<Props, State> {
  state: State = {
    name: '',
    nameError: false,
    nameId: '',
    safetyPolicy: true,
    safetyPolicyError: false,
    submitting: false,
  };

  componentWillMount() {
    this.setState({ nameId: uniqueId('id-') });
  }

  componentDidMount() {
    this.setUserName();
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.stripeCallStatus === 'done' && this.props.stripeCallStatus !== 'done') {
      this.handlePayment(nextProps.sourceId);
    }
  }

  setUserName = () => {
    this.setState({ name: CurrentUser.getUser().getFullName() });
  };

  handleNameBlur = (event: SyntheticEvent<>) => {
    // $FlowFixMe
    const nameValid = event.target.checkValidity();

    if (nameValid) {
      this.setState({ nameError: false });
    } else {
      this.setState({ nameError: 'Card owner’s name is required' });
    }
  };
  handleNameChange = (event: SyntheticEvent<>) => {
    this.setState({
      // $FlowFixMe
      name: event.target.value,
    });
  };
  handleNameFocus = () => {
    this.setState({ nameError: false });
  };

  handleSafetyPolicyChange = () => {
    const value = !this.state.safetyPolicy;
    this.setState({ safetyPolicy: value });
    if (value) {
      this.setState({ safetyPolicyError: false });
    } else {
      this.setState({ safetyPolicyError: 'Permission is required' });
    }
  };
  checkValidity = () => {
    return this.state.name !== '' && this.props.inputValid && this.state.safetyPolicy;
  };
  handleSubmit = (event: SyntheticEvent<>) => {
    event.preventDefault();
    this.setState({ submitting: true });
    this.props.setStripeCallStatus('start');
  };
  handlePayment = (sourceId: ?string) => {
    const onSuccess = () => {
      ToastActions.showSuccessToast('Transaction successful');
      this.setState({ submitting: false });
      this.props.reinitialize();
      this.props.onProceed();
    };
    const onError = error => {
      if (error.field_errors) {
        ToastActions.showAPIError(error);
      } else {
        ToastActions.showErrorToast(
          `
          There was an error with your transaction. Please try again or email
          ${LinkConstants.SUPPORT_EMAIL}
          for help.
        `
        );
      }
    };

    if (sourceId) {
      FamilyActions.sendConsentPayment(this.props.childId, sourceId, this.state.name).then(
        onSuccess,
        onError
      );
    } else {
      // There was an error in adding card to Stripe
      onError({});
    }
  };

  render() {
    const { name, nameError, nameId, safetyPolicy, safetyPolicyError, submitting } = this.state;

    const { errorMessage } = this.props;
    const safetyPolicyLabel = (
      <span>
        I’ve read and understand how{' '}
        <ModalTrigger modal={<ParentalConsentPersonalInfoModal />}>
          <Link>Remind uses personal information</Link>
        </ModalTrigger>
        . I give my child permission to use Remind.
      </span>
    );
    return (
      <section className="ParentalConsentCardView">
        <BoxHeader
          title="Verify your identity with a card"
          subtext={`${CONSENT_CHARGE_AMOUNT} will be charged to your card. We’ll refund it soon!`}
        />
        <BoxBody>
          <form onSubmit={this.handleSubmit}>
            <Field error={nameError}>
              <Label htmlFor={nameId}>Name</Label>
              <Input
                id={nameId}
                placeholder="Enter your name as it appears on your card"
                required
                value={name}
                onBlur={this.handleNameBlur}
                onChange={this.handleNameChange}
                onFocus={this.handleNameFocus}
              />
            </Field>
            <Field error={errorMessage}>
              <Label>Debit or credit card</Label>
              <CreditCardInput apiKey={Config.Environment.STRIPE_KEY} />
            </Field>
            <Field error={safetyPolicyError}>
              <Checkbox
                label={safetyPolicyLabel}
                defaultChecked={safetyPolicy}
                required
                onChange={this.handleSafetyPolicyChange}
              />
            </Field>
            <Button type="submit" disabled={!this.checkValidity()} full loading={submitting}>
              Submit
            </Button>
            <EncryptionNotice />
          </form>
        </BoxBody>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    inputValid: state.creditCards.inputValid,
    errorMessage: state.creditCards.errorMessage,
    stripeCallStatus: state.creditCards.stripeCallStatus,
    sourceId: state.creditCards.sourceId,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators(
    {
      setStripeCallStatus,
      reinitialize,
    },
    dispatch
  );
}
export { ParentalConsentCardView };
export default connect(mapStateToProps, mapDispatchToProps)(ParentalConsentCardView);
